import Vue from 'vue';
import api from '@/api';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SET_CHILD_MODULE: 'SET_CHILD_MODULE',
    SAVE_FILTERS: 'SAVE_ANALYTICS_FILTERS',
    SAVE_FILTERS_SETTINGS: 'SAVE_ANALYTICS_FILTERS_SETTINGS',
    RESET_FILTERS: 'RESET_ANALYTICS_FILTERS',
    RECEIVE_KPI_LIST: 'RECEIVE_ANALYTICS_KPI_LIST',
    RECEIVE_KPI_FRAUD_LIST: 'RECEIVE_ANALYTICS_KPI_FRAUD_LIST',
};

const initialState = {
    kpiList: [],
    kpiFraudList: [],
    filters: {},
    filtersSettings: {},
    activeChild: '',
};

const initialFilterProps = {
    sort: '-profit',
    limit: 20,
    offset: 0,
};

const state = {
    ...initialState,
};

const getters = {
    analyticsKpiList: state => state.kpiList,
    analyticsKpiFraudList: state => state.kpiFraudList,
    analyticsFilters: state => state.filters,
    filtersSettings: state => state.filtersSettings,
};


const actions = {
    setActiveChildModule ({ commit }, childName) {
        commit(types.SET_CHILD_MODULE, childName);
    },
    saveAnalyticsFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    saveAnalyticsFiltersSettings ({ commit }, payload) {
        commit(types.SAVE_FILTERS_SETTINGS, payload);
    },
    getAnalyticsKpiList ({ commit }, payload) {
        return api.analytics.kpiList(payload).then(({ data }) => {
            commit(types.RECEIVE_KPI_LIST, data.data);
        });
    },
    getAnalyticsKpiFraudList ({ commit }, payload) {
        return api.analytics.kpiFraudList(payload).then(({ data }) => {
            commit(types.RECEIVE_KPI_FRAUD_LIST, data.data);
        });
    },
    resetAnalyticsFilters ({ commit }, payload) {
        commit(types.RESET_FILTERS, payload);
    },
};


const mutations = {
    [types.SET_CHILD_MODULE] (state, childName) {
        state.activeChild = childName;
    },
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        Vue.set(state.filters, [state.activeChild], { ...initialFilterProps, ...payloadNormalized });
    },
    [types.SAVE_FILTERS_SETTINGS] (state, payload) {
        Vue.set(state.filtersSettings, [state.activeChild], payload);
    },
    [types.RECEIVE_KPI_LIST] (state, data) {
        state.kpiList = Object.values(data);
    },
    [types.RECEIVE_KPI_FRAUD_LIST] (state, data) {
        state.kpiFraudList = Object.values(data);
    },
    [types.RESET_FILTERS] (state, data) {
        Vue.set(state.filters, [state.activeChild], { ...initialFilterProps, ...data });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
